Vue.component("sWheel", {
    props: ["config"],
    template: `
        <div class="sWheel">
            <img class="sWheel__module sWheel__module1" :src="module1img">
            <img class="sWheel__module sWheel__module2" :src="module2img">
            <img class="sWheel__module sWheel__module3" :src="module3img">
            <img class="sWheel__module sWheel__module4" :src="module4img">
            <img class="sWheel__module sWheel__module5" :src="module5img">
        </div>
    `,
    data() {
        return {
            get completedHotspots() {
                return app.localStore.get("hotspots-completed").completed || []
            },
            module1img: '',
            module2img: '',
            module3img: '',
            module4img: '',
            module5img: '',

            imgDirectory: config.BACKGROUND_IMAGE_DIRECTORY || '',
            videoDirectory: config.BACKGROUND_VIDEO_DIRECTORY || ''
        }
    },
    created() {
        this.updateModuleImages();
    },
    mounted() {
        window.addEventListener('hotspotcompleted', (event) => {
            this.updateModuleImages();
        }, false);
    },
    methods: {
        updateModuleImages() { 
            this.module1img = this.completedHotspots.includes(this.config.module1) ? "assets/img/5s/sorter.svg" : "assets/img/5s/sorter-inactive.svg";
            this.module2img = this.completedHotspots.includes(this.config.module2) ? "assets/img/5s/system.svg" : "assets/img/5s/system-inactive.svg";
            this.module3img = this.completedHotspots.includes(this.config.module3) ? "assets/img/5s/rengoring.svg" : "assets/img/5s/rengoring-inactive.svg";
            this.module4img = this.completedHotspots.includes(this.config.module4) ? "assets/img/5s/standardiser.svg" : "assets/img/5s/standardiser-inactive.svg";
            this.module5img = this.completedHotspots.includes(this.config.module5) ? "assets/img/5s/selvdisciplin.svg" : "assets/img/5s/selvdisciplin-inactive.svg";
        }
    },
    destroyed() {
        window.removeEventListener('hotspotcompleted', (event) => {
            this.updateModuleImages();
        }, false);
    },
});